{
	"poa": {
		"label": "NY Power of Attorney",
		"agents": "poa",
		"mode": "selected",
		"sources": {
			"client": "POA NY- immediate -2025 - CLIENT.docx",
			"spouse": "POA NY- immediate -2025 - spouse.docx"
		},
		"hashes": {
			"client": "65fa4b5d022ea4a194d63f762f9ce475f9a6744c86a822367edbf7a4e0219b08",
			"spouse": "130a72becf3dadcd8c0e549ccbb1beccda8bbb27a26ec943bd3f7edd1cc2c3e7"
		}
	},
	"hcp": {
		"label": "NY Health Care Proxy",
		"agents": "health_proxy",
		"mode": "selected",
		"sources": {
			"client": "NY HCP - CLIENT.docx",
			"spouse": "NY HCP - Spouse.docx"
		},
		"hashes": {
			"client": "805e4ab4be0622f4a72969838228086bbbf9ee29c2e55b498b98a0a4d36b8a05",
			"spouse": "e8a773eff3f478e1f926e2e000db512bf9c3a240b3abdd2b07463b850d45c1fc"
		}
	},
	"digital-assets": {
		"label": "Digital Asset Authorization",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "DIGITAL ASSET AUTHORIZATION - CLIENT.docx",
			"spouse": "DIGITAL ASSET AUTHORIZATION - spouse.docx"
		},
		"hashes": {
			"client": "211fb1d418a681018db16720b992969956fc44f3b83411b61c309924901650f8",
			"spouse": "d3a3521a818cdc9d6ee8c026ffeff5227b66a468e1cd1462d570287d0e1e97e2"
		}
	},
	"fl-health-care": {
		"label": "FL Health Care Surrogate",
		"agents": "health_proxy",
		"mode": "selected",
		"sources": {
			"client": "FL Health Care - CLIENT.docx",
			"spouse": "FL Health Care - spouse.docx"
		},
		"hashes": {
			"client": "784dd8a9b81784c3f23d63a45ca96fdde28bee95cad8d79edfd0157ee61c17d4",
			"spouse": "bc25deb3f04b74505e6f82778d86c60db08e42041011a5450eed1062e9b9c027"
		}
	},
	"nj-health-care": {
		"label": "NJ Health Care Proxy",
		"agents": "health_proxy",
		"mode": "selected",
		"sources": {
			"client": "HCP - NJ  - CLIENT.docx",
			"spouse": "HCP - NJ  - spouse.docx"
		},
		"hashes": {
			"client": "2c8e4b6f0f0f5d9a7513078403a3b6314c978f8d9dfa2bd73a2394c275c5fe9d",
			"spouse": "89fe51a7f11509c7604f12d1afd7037635e595318cb4b4ef1a80afd887f15652"
		}
	},
	"fl-living-will": {
		"label": "FL Living Will",
		"agents": "health_proxy",
		"mode": "selected",
		"sources": {
			"client": "LIVING WILL- FL - CLIENT.docx",
			"spouse": "LIVING WILL- FL - spouse.docx"
		},
		"hashes": {
			"client": "81d73316891daa8f6748a51374ea61d2c30d3be453afda34fd6a8616b352e25b",
			"spouse": "ce5ddcec2ab3f20a158deb8a2de8b16bf9bfcad6a22e7b29e53923e9db9eedd6"
		}
	},
	"nj-living-will": {
		"label": "NJ Living Will",
		"agents": "health_proxy",
		"mode": "selected",
		"sources": {
			"client": "Living Will - NJ - CLIENT.docx",
			"spouse": "Living Will - NJ - Spouse.docx"
		},
		"hashes": {
			"client": "cc74bfde4485aed10156b8b34bf4a1d1f6a310627832025bace02a790c0aa835",
			"spouse": "fbd7b50fa7794ad594809004ed3f875757a53def00638f75509d3a378fa661aa"
		}
	},
	"ny-living-will": {
		"label": "NY Living Will",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Living Will-NY - CLIENT.docx",
			"spouse": "Living Will-NY - spouse.docx"
		},
		"hashes": {
			"client": "9cf471709266a9e6436eaa591052691ca28f04dd59a499add6c4170201047aa1",
			"spouse": "17faf2ccce5fe1e50db586056c3cfa087d1af8360bf0241e67e7d00b3f396c55"
		}
	},
	"nj-poa": {
		"label": "NJ Power of Attorney",
		"agents": "poa",
		"mode": "selected",
		"sources": {
			"client": "POA in NJ - CLIENT.docx",
			"spouse": "POA in NJ - spouse.docx"
		},
		"hashes": {
			"client": "db608ea0c1e0ef34f54d78ab15652ed95de106307ad522e58205c73a959df948",
			"spouse": "6862b1ca9c7913df271dab8d4d8431f69213fbd836f60ae7f60edcbe9f18fb38"
		}
	},
	"fl-poa-client": {
		"label": "FL Power of Attorney — Client template",
		"agents": "poa",
		"mode": "client",
		"sources": {
			"client": "NEW - FL-POA - CLIENT.docx"
		},
		"hashes": {
			"client": "87ebda2c99e92fef47b6afc35bc4d26eb7bb7d1607e00e19fda4a201896dd0fc"
		}
	},
	"fl-poa-spouse": {
		"label": "FL Power of Attorney — Spouse template",
		"agents": "poa",
		"mode": "spouse",
		"sources": {
			"spouse": "NEW - FL-POA - spouse.docx"
		},
		"hashes": {
			"spouse": "39fcfb4a94241255b1d103f52c0f0b985d2ad1ffd568d47b6d82b780cd9623b5"
		}
	},
	"ny-poa-single": {
		"label": "NY Power of Attorney — Single / two primary agents",
		"agents": "poa",
		"mode": "selected",
		"sources": {
			"client": "POA NY- immediate -2025 - single.docx"
		},
		"hashes": {
			"client": "908ba4e4fa01ffb986d4cf13d1fb433bda52cfca568cee2489db8c7c1cf236be"
		}
	},
	"ny-hcp-single": {
		"label": "NY Health Care Proxy — Single / two primary agents",
		"agents": "health_proxy",
		"mode": "selected",
		"sources": {
			"client": "NY HCP - single.docx"
		},
		"hashes": {
			"client": "2e8f153bf7ba92c3f0d73436b75ee53666257965c00026de3b54b81a4d9338d7"
		}
	},
	"condo-mortgage": {
		"label": "Condominium Contract — With mortgage and rider",
		"agents": "none",
		"mode": "intake",
		"sources": {
			"client": "Condo_Contract_WordTEMPLATEWMORTGAGE_andwRider.docx"
		},
		"hashes": {
			"client": "c2491f68bbc52e3258f21dd1b2853f02326ade1c9328ef26ccb10ddb481f1462"
		}
	},
	"condo-no-mortgage": {
		"label": "Condominium Contract — Without mortgage and with rider",
		"agents": "none",
		"mode": "intake",
		"sources": {
			"client": "Condo_Contract_WordTEMPLATEWITHOUTMORTGAGE_andwRider.docx"
		},
		"hashes": {
			"client": "dc775f37191ca50b3afae51243124b7f5b6127153fbe39c25b00cb4d4619aab8"
		}
	},
	"coop-mortgage": {
		"label": "Cooperative Contract — With mortgage and rider",
		"agents": "none",
		"mode": "intake",
		"sources": {
			"client": "TEMPLATE_CONTRACT_COOP_SUBCOMMITTEE01-03-2023WITHMORTGAGE_andwRider.docx"
		},
		"hashes": {
			"client": "4fd62a19d5cea9fa08fc2423b110ee970be6d6cc451023814bd4017ef3e5d77b"
		}
	},
	"coop-no-mortgage": {
		"label": "Cooperative Contract — Without mortgage and with rider",
		"agents": "none",
		"mode": "intake",
		"sources": {
			"client": "TEMPLATE_CONTRACT_COOP_SUBCOMMITTEE01-03-2023WITHOUTMORTGAGE_andwRider.docx"
		},
		"hashes": {
			"client": "657ab0f7201742c5f309ace0d8ba1d304aa823d2216068cb2715531f4b0e8bdb"
		}
	},
	"residential-mortgage": {
		"label": "Residential Contract — With mortgage and rider",
		"agents": "none",
		"mode": "intake",
		"sources": {
			"client": "Residential contractwMortgage_andwRider.docx"
		},
		"hashes": {
			"client": "e96f5830e7cbf7963c7f8d57196b5305408db7b0fab42c047d82fc7a08ac47e1"
		}
	},
	"residential-no-mortgage": {
		"label": "Residential Contract — Without mortgage and with rider",
		"agents": "none",
		"mode": "intake",
		"sources": {
			"client": "Residential contractwWITHOUTMortgage_andwRider.docx"
		},
		"hashes": {
			"client": "cfc0000cce44545e5cf85d544c7523706ce38191193e798ca93b6fdd58ec8c08"
		}
	},
	"engagement-fl-flat": {
		"label": "Engagement Letter — FL flat fee",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Engagement_Letter_FL_Flat.docx"
		},
		"hashes": {
			"client": "4ac5ca6f9fecb7f0380879f71fa0e012f50598af54e1c40391680868f2c1fe70"
		}
	},
	"engagement-fl-hourly": {
		"label": "Engagement Letter — FL hourly",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Engagement_Letter_FL_Hourly.docx"
		},
		"hashes": {
			"client": "8efc04657372dab1e1af9e485caa82f7a52f0c9d4d9a60b70c294bbea1e76e71"
		}
	},
	"engagement-nj-purchase": {
		"label": "Engagement Letter — NJ purchase",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Engagement_Letter_NJ_Purchase.docx"
		},
		"hashes": {
			"client": "f263abfec6408b67b5e4c6b3404262adaa5a003eb915c88e9ea94671a3dc51f5"
		}
	},
	"engagement-purchase": {
		"label": "Engagement Letter — Purchase",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Engagement_Letter_Purchase.docx"
		},
		"hashes": {
			"client": "7e57c66ae52790d3cf150f7158c80168146896f279ff78f35c1485a0a4246c33"
		}
	},
	"engagement-sale": {
		"label": "Engagement Letter — Sale",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Engagement_Letter_Sale.docx"
		},
		"hashes": {
			"client": "a775ac79e807396862ae84383a4180d32aff1846cba8f6763919856f8c95f925"
		}
	},
	"grantor-nj-fl-married": {
		"label": "Grantor Letter — NJ and FL married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Grantor Letter - NJ & FL- married.docx"
		},
		"hashes": {
			"client": "9cb3f2fb73a44fed95fd41f9ad21f550babc1c9f566affe2d82cf250d0881e1d"
		}
	},
	"grantor-nj-fl-single": {
		"label": "Grantor Letter — NJ and FL single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Grantor Letter - NJ & FL - single.docx"
		},
		"hashes": {
			"client": "9b574c2d398353460fd547c09dea688f432f7a935216d33b6e2f52ebe89c9e55"
		}
	},
	"grantor-ny-married": {
		"label": "Grantor Letter — NY married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Grantor Letter - NY- married.docx"
		},
		"hashes": {
			"client": "9a07c81f50c26b4b53e0ed6783e3a4f2ac88dd5910d83368c9fe38c154f7b834"
		}
	},
	"grantor-ny-single": {
		"label": "Grantor Letter — NY single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Grantor Letter - NY - single.docx"
		},
		"hashes": {
			"client": "8f063fd7e3671afe587c305ed200f6be0b491e55a114b6e3c02a356f04c5655d"
		}
	},
	"non-grantor-married": {
		"label": "Non Grantor Letter — NY NJ FL married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Non Grantor Letter - NY NJ FL- married.docx"
		},
		"hashes": {
			"client": "1c1aa5386047e85691f7606c29ba9a21bd0e6af14652a2d6eb978842e26d8097"
		}
	},
	"non-grantor-single": {
		"label": "Non Grantor Letter — NY NJ FL single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Non Grantor Letter - NY NJ FL - single.docx"
		},
		"hashes": {
			"client": "fe2268af309edc5a9b72fc46256e8599cb75afc0a23a681b1ffc3de9c4d06004"
		}
	},
	"instruction-one-beneficiary": {
		"label": "Instruction Letter — One beneficiary",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Instruction Letter Beneficiary - 1.docx"
		},
		"hashes": {
			"client": "592c50de6e6b363813abc15ecebb51d8ab392feaaaa5f543cd38ef7946f7fd99"
		}
	},
	"instruction-one-not-beneficiary": {
		"label": "Instruction Letter — One non-beneficiary",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Instruction Letter Not Beneficiary - 1.docx"
		},
		"hashes": {
			"client": "04814756f449ff80928571ae24f7cd30c2aeb8569158ea2a36f239dad9ea6ab3"
		}
	},
	"instruction-two-beneficiaries": {
		"label": "Instruction Letter — Two beneficiaries",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Instruction Letter 2 Beneficiaries.docx"
		},
		"hashes": {
			"client": "6ca80618d3f65b5ec8a3e3735e2f5eb605b6633e9789698b1359b4b77e50af92"
		}
	},
	"instruction-two-not-beneficiaries": {
		"label": "Instruction Letter — Two non-beneficiaries",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Instruction Letter 2 Not Beneficiaries.docx"
		},
		"hashes": {
			"client": "08d3237db31863fa12c29780b27a980601e860badb694bb8be24b1fb26dbf47c"
		}
	},
	"retainer-coop-married": {
		"label": "Retainer Agreement — Cooperative married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Retainer Agreement - COOP Married.docx"
		},
		"hashes": {
			"client": "d667fba3723420245f7ada2b299e3a206ff57b270901393f3cd333db5e0d6d99"
		}
	},
	"retainer-coop-single": {
		"label": "Retainer Agreement — Cooperative single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Retainer Agreement 1+Coop.docx"
		},
		"hashes": {
			"client": "51d76486d74eaca7d82437a74cb365897b603f30f3a75e84bc197f0e16668fc5"
		}
	},
	"retainer-fl-married": {
		"label": "Retainer Agreement — FL married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Retainer Agreement - Married - FL.docx"
		},
		"hashes": {
			"client": "de96cd14d595a693503187647926dc9c6f147a0557169c76b47401db302def6d"
		}
	},
	"retainer-fl-single": {
		"label": "Retainer Agreement — FL single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Retainer Agreement - Single - FL.docx"
		},
		"hashes": {
			"client": "51a41adff9f96b63f9095b8a3a2014b6e3bd62cdec4d6537013705a82c823f72"
		}
	},
	"retainer-married": {
		"label": "Retainer Agreement — Married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Retainer Agreement - Married.docx"
		},
		"hashes": {
			"client": "2a7412f177a32e9cf5966414afdec8ee02f8af472232118de39a366ba201ebdd"
		}
	},
	"retainer-medicaid-married": {
		"label": "Retainer Agreement — Medicaid married",
		"agents": "none",
		"mode": "joint",
		"sources": {
			"client": "Retainer Agreement married Medicaid.docx"
		},
		"hashes": {
			"client": "2d48bfc00a0e7d4d5a68721cdbcba65497e8ea658d38149bdbf3f079833d29de"
		}
	},
	"retainer-medicaid-single": {
		"label": "Retainer Agreement — Medicaid single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Retainer Agreement 1+Medicaid.docx"
		},
		"hashes": {
			"client": "4fa026de7a19f7c857f9108955cdbd220bef3db770509ec23377f685f2f0b143"
		}
	},
	"retainer-ny-flat": {
		"label": "Retainer Agreement — NY flat fee",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Retainer_New_York_Flat.docx"
		},
		"hashes": {
			"client": "b0822c05daadca0ab63ca0020bd80aba3810dc2fc2f258ab5d168c8bbe76bb7b"
		}
	},
	"retainer-ny-hourly": {
		"label": "Retainer Agreement — NY hourly",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Retainer_New_York_Hourly.docx"
		},
		"hashes": {
			"client": "ff005412ef49cd2cd8b6260704738fb775a0b9836a6885026c17a3dcf6b4f013"
		}
	},
	"retainer-single": {
		"label": "Retainer Agreement — Single",
		"agents": "none",
		"mode": "selected",
		"sources": {
			"client": "Retainer Agreement - Single (1).docx"
		},
		"hashes": {
			"client": "5d88f890745d9a9b13556ea22cf40498bff5c958841da91eb7db85768cb152d2"
		}
	}
}
